import {useContext} from "react";
import LayoutContext from "../LayoutContext";
import {Button} from "@mantine/core";
import {IconSquareRoundedArrowLeft, IconSquareRoundedArrowRight} from "@tabler/icons-react";

/**
 * Toggle button for layout.
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function ToggleButton() {
    /**
     * Layout context.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(LayoutContext);

    /**
     * Get icon in dependant of state.
     * @author Kacper Faber
     * @since 0..18
     */
    const getIcon = (isOpened: boolean) => {
        return isOpened ? <IconSquareRoundedArrowLeft/> : <IconSquareRoundedArrowRight/>;
    }

    return (
        <>
            <Button
                variant="subtle"
                children={getIcon(ctx.mobileOpened)}
                hiddenFrom="sm"
                onClick={ctx.toggleMobile}
            />

            <Button
                variant="subtle"
                children={getIcon(ctx.desktopOpened)}
                visibleFrom="sm"
                onClick={ctx.toggleDesktop}
            />
        </>
    );
}

export default ToggleButton;